import translationEN from './locales/en-GB.json';

const resources = { 'en-GB': { translation: translationEN } };

export default resources;
